import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import PortalIdParser from 'PortalIdParser';
import { callingMarketplaceAppsUrl } from 'calling-lifecycle-internal/utils/urlUtils';
import getAppUrls from 'calling-orchestration-shared-library/constants/appUrls';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const portalId = PortalIdParser.get() || '';
function GlobalCallingDisabled() {
  const {
    callingConfigurationSettingsUrl
  } = getAppUrls();
  return /*#__PURE__*/_jsxs(Flex, {
    alignSelf: "center",
    justifyContent: "center",
    padding: '600',
    maxInlineSize: '500px',
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "calling",
      width: "15%"
    }), /*#__PURE__*/_jsxs(View, {
      paddingInlineStart: "600",
      children: [/*#__PURE__*/_jsx(H4, {
        "data-selenium-test": "calling-disabled-message",
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "globalCallingDisabled.title"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "globalCallingDisabled.message_jsx",
          elements: {
            UILink: Link
          },
          options: {
            settingsLinkProps: {
              href: callingConfigurationSettingsUrl
            },
            marketplaceLinkProps: {
              href: callingMarketplaceAppsUrl(portalId)
            }
          }
        })
      })]
    })]
  });
}
export default GlobalCallingDisabled;